'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = expireSessionSaga;

var _effects = require('redux-saga/effects');

var _selectSession = require('../../selectors/context/selectSession');

var _setSessionSaga = require('./setSessionSaga');

var _setSessionSaga2 = _interopRequireDefault(_setSessionSaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(expireSessionSaga);

function expireSessionSaga() {
    var session;
    return regeneratorRuntime.wrap(function expireSessionSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)((0, _selectSession.selectSession)());

                case 2:
                    session = _context.sent;

                    session = { culture: session.culture };
                    _context.next = 6;
                    return (0, _setSessionSaga2.default)({ payload: session });

                case 6:
                    return _context.abrupt('return', session);

                case 7:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}